import Vue from 'vue'
import {
  AclInstaller,
  AclCreate,
  AclRule
} from 'vue-acl'
import router from '@/router'
import { CHECK_AUTH } from '@/store/action.types'
import store from '@/store/store'
// import AuthService from '@/common/auth.service'

Vue.use(AclInstaller)

const initialRole = 'public'

export default new AclCreate({
  initial: initialRole,
  notfound: '/not-authorized',
  router,
  acceptLocalRules: true,
  globalRules: {
    company: new AclRule('company').generate(),
    employee: new AclRule('employee').generate(),
    public: new AclRule('public').or('employee').or('company').generate()
  },
  middleware: async acl => {
    if (store.getters.isAuthenticated) {
      if (!store.getters.currentRoles) {
        // await AuthService.getUserData() // call your api
        await store.dispatch(CHECK_AUTH)
      }

      if (store.getters.currentRoles.includes('COMPANY')) {
        acl.change('company')
      } else if (store.getters.currentRoles.includes('EMPLOYEE')) {
        acl.change('employee')
      }
    }
  }
})
